import { useState, useEffect, useRef } from 'react';
function useElementDimensions(ref) {
    const [dimensions, setDimensions] = useState(null);
    const observer = useRef(null);
    useEffect(() => {
        if (!ref.current) {
            return;
        }
        const updateDimensions = () => {
            if (ref.current) {
                const { offsetWidth: width, offsetHeight: height } = ref.current;
                setDimensions({ width, height });
            }
        };
        updateDimensions();
        observer.current = new ResizeObserver(() => {
            requestAnimationFrame(updateDimensions);
        });
        const currentObserver = observer.current;
        currentObserver.observe(ref.current);
        return () => {
            if (currentObserver) {
                currentObserver.disconnect();
            }
        };
    }, [ref, ref.current]);
    return dimensions;
}
export default useElementDimensions;
//# sourceMappingURL=index.js.map